import React from 'react';
import PropTypes from 'prop-types';
import { Loader as LoadComp } from '@vds/loaders';

const Loader = (props) => (
  <LoadComp {...props} />
);
Loader.defaultProps = {
  active: false,
  fullscreen: false,
};
Loader.propTypes = {
  active: PropTypes.bool,
  fullscreen: PropTypes.bool,
  id: PropTypes.string,
};
export default Loader;
